// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
Widgets.YesNo = {
    //default labels
    message: 'Are you sure?',
    yes: 'Confirm',
    no: 'Cancel',

    create: function(options) {
        function F() {}
        F.prototype = this;
        var self = new F();

        if (options.message) {
            self.message = options.message;
        }
        if (options.yes) {
            self.yes = options.yes;
        }
        if (options.no) {
            self.no = options.no;
        }
        if (options.onYes) {
            self.onYes = options.onYes;
        }
        if (options.onNo) {
            self.onNo = options.onNo;
        }

        if (options.nextTo) {
            self.target = options.nextTo;

            var downOffset = options.down || 20;
            var alongOffset = options.along || 0;

            var targetOffset = $(self.target).offset();
            self.offset = {
                left: targetOffset.left + alongOffset,
                top: targetOffset.top + downOffset
            };
        }

        self.raw_el = JSML.transform(['div.yes-no-widget',
        ['div.yes-no-widget-message', self.message],
        ['div.yes-no-widget-buttons',
        ['img.yes-no-spinner', {
            src: $image_url('spinner.gif'),
            style: 'display: none;'
        }],
        ' ',
        ['a.no', {
            href: '#',
            onclick: function() {
                self.onNo.apply(self);
                return false;
            }
        },
        self.no],
        ' ',
        ['a.yes', {
            href: '#',
            onclick: function() {
                self.onYes.apply(self);
                return false;
            }
        },
        self.yes]
        ]
        ]);

        self.j_el = $(self.raw_el);
        self.j_el.css({
            'position': 'absolute',
            'left': self.offset.left,
            'top': self.offset.top,
            'z-index': 100000
            //make this calucluated
        });

        if (self.dimensions) {
            self.j_el.css({
                width: '' + self.dimensions.width + 'px',
                height: '' + self.dimensions.height + 'px'
            });
        }

        self.j_el.hide();

        document.body.appendChild(self.raw_el);
        return self;
    },

    waiting: function(on) {
        if (on) {
            this.j_el.find('.yes-no-spinner').show();
        }
        else {
            this.j_el.find('.yes-no-spinner').hide();
        }
    },


    //default behaviours
    onNo: function() {
        this.fadeOutAndRemove('fast');
        return false;
    },

    fadeIn: function() {
        this.j_el.fadeIn('fast');
    },

    fadeOutAndRemove: function(speed, callback) {
        var el = this.j_el;
        el.fadeOut(speed,
        function() {
            el.remove();
        });
        if (callback) {
            callback();
        }
    }
};
